export default __webpack_public_path__ + "static/media/login-gelombang.e247b685.svg";